import { createSelector } from '@reduxjs/toolkit'

import { ApplicationState } from 'redux/Stores/types'
import { IDashboardExample } from 'types/GlobalDashboardExample'
import { TFetchStatus } from 'redux/reducers/Dashboards'

export const selectDashboardExamples = createSelector(
  [
    // Input selectors:
    (state: ApplicationState) => state.DashboardExampleStore.data
  ],
  (data) => data
)

export const selectDashboardExample = createSelector(
  [
    // Input selectors:
    (state: ApplicationState) => state.DashboardExampleStore.data,
    (state: ApplicationState, id: string) => id
  ],
  (data, id): IDashboardExample | null => {
    const example = data[id]

    if (!example) {
      return null
    }

    return example
  }
)

export const selectDashboardExamplesFetchStatus = createSelector(
  [(state: ApplicationState) => state.DashboardExampleStore.fetchStatus],
  (fetchStatus): TFetchStatus => fetchStatus
)

export const selectDashboardExamplesNrOfCustomers = createSelector(
  [(state: ApplicationState) => state.DashboardExampleStore.nr_of_customers],
  (nr_of_customers): number => nr_of_customers
)
